import { Coberturas, Seguradoras, valoresCoberturas } from "#/enums";

export const coberturasBasico = {
  [Seguradoras.ALIRO]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.CINQUENTA_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.CINQUENTA_MIL,
    },
  ],
  [Seguradoras.YELUM]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.CEM_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.CEM_MIL,
    },
    {
      label: Coberturas.DANOS_MORAIS,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.INVALIDEZ,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.MORTE,
      value: valoresCoberturas.DEZ_MIL,
    },
  ],
};

export const coberturasIntermediario = {
  [Seguradoras.ALIRO]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.CEM_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.CEM_MIL,
    },
    {
      label: Coberturas.DANOS_MORAIS,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.INVALIDEZ,
      value: valoresCoberturas.CINCO_MIL,
    },
    {
      label: Coberturas.MORTE,
      value: valoresCoberturas.CINCO_MIL,
    },
  ],
  [Seguradoras.YELUM]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.CENTO_E_CINQUENTA_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.CENTO_E_CINQUENTA_MIL,
    },
    {
      label: Coberturas.DANOS_MORAIS,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.INVALIDEZ,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.MORTE,
      value: valoresCoberturas.DEZ_MIL,
    },
  ],
};

export const coberturasAvancado = {
  [Seguradoras.ALIRO]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: "Franquia normal",
      value: "R$ 6.282,00",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.CENTO_E_CINQUENTA_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.CENTO_E_CINQUENTA_MIL,
    },
    {
      label: Coberturas.DANOS_MORAIS,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.INVALIDEZ,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.MORTE,
      value: valoresCoberturas.DEZ_MIL,
    },
  ],
  [Seguradoras.YELUM]: [
    {
      label: Coberturas.MODALIDADE,
      value: "Seguro total",
    },
    {
      label: "Franquia reduzida",
      value: "R$ 2.731,00",
    },
    {
      label: Coberturas.DANOS_MATERIAIS,
      value: valoresCoberturas.DUZENTOS_MIL,
    },
    {
      label: Coberturas.DANOS_CORPORAIS,
      value: valoresCoberturas.DUZENTOS_MIL,
    },
    {
      label: Coberturas.DANOS_MORAIS,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.INVALIDEZ,
      value: valoresCoberturas.DEZ_MIL,
    },
    {
      label: Coberturas.MORTE,
      value: valoresCoberturas.DEZ_MIL,
    },
  ],
};
